module.exports = __webpack_public_path__ + "media/customizations/verandaliving/logo-1c4fed28ef319d426f094d0ec2ce5b67.png";